import { Box, Tabs, useTheme } from '@mui/material';
import { TabsProps as MUITabsProps } from '@mui/material';

import { PageTab, PageTabProps } from './PageTab';

interface LocalPageTabsProps {
  id: string;
  tabs: PageTabProps[];
  rightContent?: React.ReactNode;
}

export type PageTabsProps = LocalPageTabsProps & Omit<MUITabsProps, 'tabs'>;

export const PageTabs = (props: PageTabsProps) => {
  const { id, tabs, rightContent, ...restPageTabs } = props;

  const theme = useTheme();

  const activeTab = tabs.find((tab) => tab.isActive)?.id;

  return (
    <Box
      data-testid={`pageHeader-tabs-${id}`}
      sx={{
        mt: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.text.secondary}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Tabs orientation="horizontal" {...restPageTabs} value={activeTab}>
        {tabs.map((tab: PageTabProps) => {
          // Don't pass isActive to the Tab component - it's not a valid prop

          return (
            <PageTab
              key={tab.id}
              value={tab.id}
              {...tab}
              sx={{
                typography: 'body2',
                fontWeight: 500,
                letterSpacing: '0.4px',
                '&.Mui-selected': {
                  color: theme.palette.primary.main, // Active tab color
                },
                '&.Mui-disabled': {
                  color: theme.palette.text.disabled, // Disabled tab color
                },
                color: theme.palette.text.secondary, // Inactive tab color
                '&:hover': {
                  color: theme.palette.text.primary, // Hover color
                },
                ...tab.sx,
              }}
            />
          );
        })}
      </Tabs>
      {rightContent && <Box>{rightContent}</Box>}
    </Box>
  );
};

export default PageTabs;
